import React from 'react';  // eslint-disable-line

const MenuArrow = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
            <path fill="none" stroke={props.color ? props.color : '#FFFFFF'} strokeLinecap="round" strokeLinejoin="round" d="M10.238 12.238L15 17l4.762-4.762" />
        </svg>
    );
};

export default MenuArrow;
